module.exports = __webpack_public_path__ + "static/media/icnst.0a5856bf.jpg";